/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Research_BodyInputs */

const en_cap_research_body = /** @type {(inputs: Cap_Research_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents gather, compare and check information, then hand back a brief where every claim links to where it came from.`)
};

const lv_cap_research_body = /** @type {(inputs: Cap_Research_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aģenti savāc, salīdzina un pārbauda informāciju un nodod kopsavilkumu, kurā katrs apgalvojums norāda uz savu avotu.`)
};

/**
* | output |
* | --- |
* | "Agents gather, compare and check information, then hand back a brief where every claim links to where it came from." |
*
* @param {Cap_Research_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_research_body = /** @type {((inputs?: Cap_Research_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Research_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_research_body(inputs)
	return en_cap_research_body(inputs)
});